import { BaseApiClient } from './base'

export class PreferencesApi extends BaseApiClient {
  async getUserPreferences(): Promise<{ preferences: any }> {
    return this.request('/user/preferences')
  }

  async updateUserPreferences(preferences: {
    preferred_study_language?: string
    preferred_interface_language?: string
    preferred_cefr_level?: string
    preferred_translation_model?: string
    user_type?: 'learner' | 'translator' | 'reader'
    native_language?: string
    onboarding_completed?: boolean
    reader_font_size?: number
    reader_theme?: 'light' | 'dark' | 'sepia'
  }): Promise<void> {
    return this.request('/user/preferences', {
      method: 'PUT',
      body: JSON.stringify(preferences),
    })
  }

  async saveApiKey(provider: string, apiKey: string): Promise<{ success: boolean; message: string }> {
    return this.request(`/user/api-keys/${provider}`, {
      method: 'PUT',
      body: JSON.stringify({ api_key: apiKey }),
    })
  }

  async deleteApiKey(provider: string): Promise<{ success: boolean; message: string }> {
    return this.request(`/user/api-keys/${provider}`, {
      method: 'DELETE',
    })
  }

  async getAvailableProviders(): Promise<{ 
    success: boolean
    providers: Record<string, {
      name: string
      models: Array<{
        id: string
        name: string
        model: string
      }>
    }>
  }> {
    return this.request('/user/api-providers')
  }
}

